module.exports = __webpack_public_path__ + "static/icon-doubt.13fdc2da.svg";